import { getShellAppIdentityFromRoute } from "./shellAppIdentity.js";

const ROUTE_TITLE_KEYS = Object.freeze({
  home: "nav.home",
  login: "auth.page.welcomeTitle",
  "reset-password": "auth.resetPassword.title",
  "auth-callback": "auth.page.welcomeTitle",
});

/**
 * Browser-Tab-Titel aus Route + i18n (Fallback bis React hydrated).
 *
 * @param {string} route
 * @param {{ titleKey?: string }|null} [shellIdentity]
 * @param {(key: string) => string} t
 */
export function resolveShellDocumentTitle(route, shellIdentity, t) {
  const translate =
    typeof t === "function" ? t : (key) => String(key || "").trim();
  const brand = translate("title.app") || "Tennis-Matches.de";
  const titleKey =
    shellIdentity?.titleKey ||
    ROUTE_TITLE_KEYS[String(route || "").trim()] ||
    "";
  const page = titleKey ? translate(titleKey) : "";
  if (!page || page === brand) return brand;
  return `${page} | ${brand}`;
}

/**
 * @param {string} route
 * @param {(key: string) => string} t
 */
export function resolveShellDocumentTitleFromRoute(route, t) {
  return resolveShellDocumentTitle(
    route,
    getShellAppIdentityFromRoute(route),
    t,
  );
}
